import './NewsHome.scss';
import NewsList from '../NewsList/NewsList';
import {getPostsList} from '../../data/articles';
import {Link} from 'react-router-dom';

export default function NewsHome() {

    // 3 latest posts, served statically from the bundled content snapshot
    const resultsData = getPostsList(3);

    return (
        <section className="news-home">
            <h2 className="news-home__title"><Link className="news-home__title-link" to={`/news/${window.location.search}`}>Updates &amp; More</Link></h2>
            <NewsList resultsData={resultsData} />
        </section>
    )
}